import { processingSessionIdFormat } from "@redotech/redo-return-id";
import * as z from "zod";
import { ItemProcessingSession } from "./item-processing";

export const completeItemProcessingSession = {
  name: "completeItemProcessingSession" as const,
  input: z.object({ sessionId: processingSessionIdFormat.schema }),
  output: z.object({ session: ItemProcessingSession }),
};
